import React from 'react'
import styles from "./block2.module.css"
import { Grid } from '@mui/material'
import LazySection from '../LazySection'

function Block2({ standardBanishingRef, standardDivineInfiniteRef, planetaryInvocationRef, zodiacalInvocationRef, theMacrocosmicRef, celestialInvocationRitual }) {
    console.log("Block2 rendered", standardBanishingRef);

    return (
        <>
            {/* <LazySection>

                <div className={styles.standard_banishing} ref={standardBanishingRef}>


                    <div className={styles.common_width}>
                        <div className={styles.column}>
                            <div className={`${styles.col12} ${styles.bgifive}`}>
                                <h2>
                                    Standard Banishing/Invocation Ritual of the Pentagram
                                </h2>
                            </div>
                        </div>

                        <div className={styles.standard_banishing_sub}>

                            <div className={`${styles.school_ritual_standard_banishing_sub_wrpr} ${styles.flx_wrpr}`}>

                                <div className={styles.school_ritual_txt_box_wrpr}>
                                    <p>The standard Banishing Ritual of the Pentagram is more than 50% of the established
                                        connection between the theurgist and the Divine.This ritual establishes the Cosmos,
                                            facilitates connection with the Divine Double, and purifies the forces of nature,
                                        aligning them with the theurgist's transcendent nature while also purifying the
                                        actions and activities of daily life. Because all other rituals incorporate the Banishing Ritual of the Pentagram, it is a component of every level of practice. In fact, if you are practicing daily or several times a week, the Banishing Ritual alone will likely comprise 70% to 80% of your total ritual practice.  Also as an added step performing the invocations of the Pentragram can be integrated as a simple elemental invocation that should be performed at least some of the time, possibly 30% to 50%, and can even be incorporated every time if there is time for it. </p>
                                </div>


                                <div className={styles.school_ritual_img_box_wrpr}>

                                    <div className={styles.component_wrpr}>

                                        <div className={styles.round_white_outer}>
                                            <h1>The <br></br><span>components<br></br> are</span></h1>
                                        </div>

                                        <div className={styles.list_wrpr}>
                                            <ul className={styles.list_wrpr_flx}>
                                                <li>1.The Grand Invocation</li>
                                                <li>3.Calling of the Guardians </li>
                                                <li>2.Casting of the Pentagrams</li>

                                                <div className={`${styles.sub_list_wrpr} ${styles.sub_list_wrpr_none}`}>
                                                    <div className={styles.sub_list}><p>Banishing</p></div>
                                                    <div className={styles.sub_list}><p> Invoking (if performing)</p></div>

                                                </div>

                                                <li>4.Closing of the Ritual</li>
                                            </ul>
                                        </div>

                                        <div className={`${styles.sub_list_wrpr} ${styles.sub_list_wrpr_blcok}`}>
                                            <div className={styles.sub_list}><p>Banishing</p></div>
                                            <div className={styles.sub_list}><p> Invoking (if performing)</p></div>

                                        </div>

                                    </div>

                                    <img src='https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/abs_img_transparent.webp' alt='Background Image' className={styles.image_abs} />

                                </div>


                            </div>



                        </div>



                    </div>


                </div>

            </LazySection> */}


            {/* <LazySection>

                <div className={styles.stndard_total_bg_wrpr} >

                    <div className={styles.standard_banishing_2} ref={standardDivineInfiniteRef}>

                        <div className={styles.common_width}>

                            <div className={styles.column}>
                                <div className={`${styles.col12} ${styles.bgifive}`}>
                                    <h2>
                                        Standard Divine Infinite Being Invocation Ritual of the Pentagram
                                    </h2>
                                </div>
                            </div>

                            <div className={styles.standard_banishing_2_sub}>
                                <div className={`${styles.school_ritual_standard_banishing_2_sub_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}>

                                    <div className={styles.school_ritual_txt_box_wrpr}>
                                        <p>The standard Divine Infinite Being Invocation Ritual of the Pentagram is considered the primary invocation of our Divine Infinite Being. This Ritual has as its pronouncement the invocation that you will find in the beginning of our Central Doctrine and listed below. It is suggested, especially if you are not working on any other specific work, that you perform this at least once a week. </p>
                                        <p>If you are able to do a dedicated period several days in a row is advised when possible.</p>
                                    </div>

                                    <div className={styles.school_ritual_img_box_wrpr}>

                                        <div className={styles.banishing_invoking_wrpr}>
                                            <h3>The components are:</h3>
                                            <div container className={styles.grid_main} spacing={4}>
                                                <Grid size={{ sm: 6, xs: 12 }} className={styles.b_i_grid}>
                                                    <div className={styles.b_i_block}>
                                                        <span>01.</span>
                                                        <span>The Grand
                                                            Invocation</span>
                                                    </div>
                                                </Grid>
                                                <Grid size={{ sm: 6, xs: 12 }} className={styles.b_i_grid}>
                                                    <div className={styles.b_i_block}>
                                                        <span>02.</span>
                                                        <span>Casting of the Pentagrams</span>
                                                    </div>

                                                    <div className={styles.sub_list_wrpr_2}>
                                                        <div className={styles.sub_list_2}><p>Banishing</p></div>
                                                        <div className={styles.sub_list_2}><p> Invoking</p>
                                                        </div>

                                                    </div>
                                                </Grid>
                                                <Grid size={{ sm: 6, xs: 12 }} className={styles.b_i_grid}>
                                                    <div className={styles.b_i_block}>
                                                        <span>03.</span>
                                                        <span>
                                                            Calling of
                                                            the Guardians</span>
                                                    </div>
                                                </Grid>
                                                <Grid size={{ sm: 6, xs: 12 }} className={styles.b_i_grid}>
                                                    <div className={styles.b_i_block}>
                                                        <span>04.</span>
                                                        <span> Central
                                                            Pronouncement
                                                            of our Divine
                                                            Infinite Being</span>
                                                    </div>
                                                </Grid>
                                                <Grid size={{ sm: 6, xs: 12 }} className={styles.b_i_grid}>
                                                    <div className={styles.b_i_block}>
                                                        <span>05.</span>
                                                        <span>

                                                            Closing
                                                            of the Ritual</span>
                                                    </div>
                                                </Grid>

                                            </div>
                                        </div>

                                    </div>


                                </div>
                            </div>
                        </div>



                    </div>

                    <div className={styles.planetary_invocation} ref={planetaryInvocationRef}>
                        <div className={styles.common_width}>

                            <div className={styles.column}>
                                <div className={`${styles.col12} ${styles.bgifive}`}>
                                    <h2>
                                        Planetary Invocation Ritual of the Pentagram
                                    </h2>
                                </div>
                            </div>

                            <div className={styles.planetary_invocation_sub}>
                                <div className={`${styles.school_ritual_planetary_invocation_sub_wrpr} ${styles.flx_wrpr} `}>

                                    <div className={styles.school_ritual_txt_box_wrpr}>
                                        <p>The Planetary Invocation Ritual is a central model and a starting point for advanced theurgic work. Our school's praxis emphasizes the invocation and amplification of all ten planetary intelligences of
                                            astrology within the theurgist's conscious awareness. This process brings the unconscious operation of planetary forces into conscious purview, allowing them to be purified, amplified, and harmonized with the theurgist's active work, karmic forces, and the laws of Dharma—all of which influence daily life.</p>
                                        <p>While this work can be done independently of studying personal Astrology, for students of our mystery school, the planetary invocations serve a dual purpose. First, they cultivate mastery over these forces, enabling the theurgist to decouple from their unconscious influence and consciously engage with their effects. Second, they prepare the student to effectively utilize Astrological transits (either personally studied or interpreted by an astrologer) to work with these forces from a place of providence, rather than being subject to fate.
                                        </p>
                                        <p>A theurgist who has purified, amplified, and invoked the energies of Saturn and Mars, effectively
                                            reconditioning their relationship with these planetary forces, will perceive a Saturn-Mars opposition or square in their personal transits not as an unalterable circumstance of fate, but as a potent opportunity for growth—even leveraging these intense energies to effect significant shifts in their personal field of conscious manifestation.</p>
                                        <p>
                                            For example, a theurgist who has purified, amplified, and invoked the energies of Saturn and Mars,
                                            effectively reconditioning their relationship with these planetary forces, will perceive a Saturn-Mars
                                            opposition or square in their personal transits as an opportunity for growth, not as an unalterable
                                            circumstance of fate, and even use these intensities to make significant shifts in their personal
                                            gravitational field of conscious manifestation.</p>
                                        <p>Beyond this core purpose, the purification and invocation of these dynamic energies offer a myriad
                                            of other benefits, including enhanced manifestation, intuitive and divinatory revelation, and countless other positive outcomes. However, the primary aim of engaging the planetary forces is a concentrated,
                                            specialized effort to consciously interact with their dynamic interplay within the realm of direct
                                            experience.</p>
                                    </div>

                                    <div className={styles.school_ritual_img_box_wrpr}>

                                        <div className={styles.component_hdr}>
                                            <h2>The components are:</h2>

                                        </div>

                                        <div className={styles.invocation_flx_wrpr}>
                                            <div className={styles.invocation_flx_left}>
                                                <div className={styles.invoc_ind}>
                                                    <span>01.The Grand Invocation</span>
                                                </div>
                                                <div className={styles.invoc_ind}>
                                                    <span>02.Casting of the Pentagrams </span>
                                                    <span> <span style={{ fontWeight: "400", marginRight: "12px" }}>A.Banishing</span> <span style={{ fontWeight: "400" }}>B.Invoking</span> </span>


                                                </div>
                                                <div className={styles.invoc_ind}>
                                                    <span>03.Calling of the Guardians</span>
                                                </div>
                                                <div className={styles.invoc_ind}>
                                                    <span>04.Opening of the Gates</span>
                                                </div>
                                            </div>
                                            <div className={styles.invocation_flx_rght}>
                                                <div className={styles.invoc_ind}>
                                                    <span>05.Planetary Invocation</span>
                                                </div>
                                                <div className={styles.invoc_ind}>
                                                    <span>06.Invocation of Hermes/Apollo</span>
                                                </div>
                                                <div className={styles.invoc_ind}>
                                                    <span>07.Planetary Pronouncement</span>
                                                </div>
                                                <div className={styles.invoc_ind}>
                                                    <span>08.Closing of the Ritual</span>
                                                </div>
                                            </div>
                                        </div>


                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>

            </LazySection> */}

            {/* <LazySection>

                <div className={styles.Zodiacal_wrpr} ref={zodiacalInvocationRef}>

                    <div className={styles.common_width}>

                        <div className={styles.column}>
                            <div className={`${styles.col12} ${styles.bgifive}`}>
                                <h2>
                                    Zodiacal Invocation Ritual of the Pentagram
                                </h2>
                            </div>
                        </div>

                        <div className={styles.Zodiacal_wrpr_sub}>

                            <div className={`${styles.Zodiacal_wrpr_sub_wrpr} ${styles.flx_wrpr} ${styles.flx_row}`}>

                                <div className={styles.school_ritual_txt_box_wrpr}>
                                    <p>The Zodiacal Invocation Ritual is precisely what it suggests: an invocation of the twelve signs of the Zodiac. While these invocations can be performed at any time and in any order, their most profound application lies in opening each sign on its corresponding day of the calendar year. Unlike the planetary intelligences, which are dynamic forces of the
                                        planetary spheres moving through spacetime and influencing us (forces with which we align ourselves to utilize their
                                        effects), the signs of the Zodiac are more akin to <span>"houses"</span> of the Sun. We exist within a sign, much like being born at a specific time, place, and day, thereby incarnating within its particular influence. These signs mark the cyclical transitions of qualia—the subjective, felt qualities of experience—
                                        imprinted upon all living beings as they journey from the waning influence of one sign, through its zenith, and into the
                                        emerging influence of the next.</p>
                                </div>
                                <div className={styles.school_ritual_img_box_wrpr}>


                                    <div className={styles.grand_invocation_wrpr}>

                                        <div className={styles.grand_invocation_hdr}>
                                            <h1>The Grand Invocation</h1>
                                        </div>

                                        <div className={styles.grand_invoc_flx}>
                                            
                                            <div className={styles.grand_invoc_flx_left}>
                                            <div className={`${styles.grand_invoc_skywrpr} ${styles.grand_invoc_skywrpr_aftr}`}>
                                                <h2>1.Casting of the Pentagrams</h2>
                                            </div>

                                            <div className={styles.banishing_invoking_flx}>
                                                <div className={styles.banishing_invoking_n}><p>Banishing</p></div>
                                                <div className={styles.banishing_invoking_n}><p>Invoking</p></div>

                                            </div>
                                            </div>
                                            <div className={styles.grand_invoc_flx_rght}>
                                            <div className={`${styles.grand_invoc_skywrpr} ${styles.flex_width}`}>
                                                <h2>2.Calling of the Guardians</h2>
                                            </div>
                                            <div className={`${styles.grand_invoc_skywrpr} ${styles.flex_width}`}>
                                                <h2>3.Invocation of Hermes/Apollo</h2>
                                            </div>
                                            <div className={`${styles.grand_invoc_skywrpr} ${styles.flex_width}`}>
                                                <h2>4.Opening of the Gates</h2>
                                            </div>
                                            <div className={`${styles.grand_invoc_skywrpr} ${styles.flex_width}`}>
                                                <h2>5.Zodiacal Pronouncement</h2>
                                            </div>
                                            <div className={`${styles.grand_invoc_skywrpr} ${styles.flex_width}`} style={{marginBottom:"0"}}>
                                                <h2>6.Zodiacal Invocation</h2>
                                            </div>
                                            <div className={`${styles.grand_invoc_skywrpr} ${styles.flex_width}`} style={{marginBottom:"0"}}>
                                                <h2>7.Closing of the Ritual</h2>
                                            </div>

                                            
                                            </div>

                                        </div>



                                    </div>

                                </div>


                            </div>

                        </div>



                    </div>


                </div>
            </LazySection> */}


            {/* <LazySection>
                <div className={styles.celestical_invocation} ref={celestialInvocationRitual}>

                    <div className={styles.common_width}>
                        <div className={styles.column}>
                            <div className={`${styles.col12} ${styles.bgifive}`}>
                                <h2>
                                    Celestial Invocation Ritual of the Pentagram
                                </h2>
                            </div>
                        </div>


                        <div className={styles.celestical_invocation_1_Innr}>
                            <div className={`${styles.celestical_invocation_1_Innr_sub} ${styles.flx_wrpr}`}>

                                <div className={styles.school_ritual_txt_box_wrpr}>
                                    <p>The Celestial Invocation Ritual possesses the broadest range of applications among all our ritual practices, serving both as a foundation for specialized personal work and as the core structure of our 15-month inner mystery school program. This ritual integrates the planetary and zodiacal invocations, allowing for the focused application of specific planetary forces within a chosen zodiacal sign. Drawing upon Mathers' pentagram arrangement within the
                                        Tarot's small cards, our 15-month program leverages this framework for invoking daemonic spirits and their corresponding designations within the astrological decan system. Each
                                        zodiacal sign is divided into three ten-day periods, each associated with a specific planetary intelligence and daemonic spirit, a process that purifies and aligns the theurgist with the
                                        generative forces of existence. A comprehensive library of these symbolic associations is available on our website under ROTA: The Wheel.</p>

                                    <p>
                                        The Celestial Pentagram is performed a minimum of 36 times within the dedicated mystery school’s required period of work, corresponding to the 36 decan positions on the astrological wheel. Upon mastering this ritual and completing the full year of dedicated practice, the
                                        theurgist can then adapt its framework to create personalized rituals for a wide variety of
                                        purposes. These include manifestation work, divinatory and intuitive practices such as Horary Astrology, and countless other applications.</p>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>

                                    

                                    <div className={styles.table_wrpr}>
                                        <div className={`${styles.tble_sec} ${styles.tble_vertical_border}`}>
                                            <div className={`${styles.tble_innr} ${styles.border_btm} ${styles.tble_innr_bg}`}>
                                                <p><span><strong>01.</strong> The Grand Invocation</span></p>
                                            </div>

                                            <div className={`${styles.tble_innr} ${styles.tble_innr_min_h} ${styles.border_btm} ${styles.tble_innr_bg}`}>
                                                <p><span><strong>02.</strong> Casting of the Pentagrams</span></p>

                                                <div className={styles.banishing_invoking}>
                                                    <p> <span><strong>A.</strong> Banishing</span> </p>
                                                    <p><span><strong>B.</strong> Invoking</span></p>

                                                </div>
                                            </div>
                                            <div className={`${styles.tble_innr} ${styles.tble_innr_bg}`}>
                                                <p><span><strong>03.</strong> Calling of the Guardians</span></p>
                                            </div>

                                        </div>

                                        <div className={`${styles.tble_sec} ${styles.tble_vertical_border}`}>
                                            <div className={`${styles.tble_innr} ${styles.border_btm_mddl} ${styles.tble_innr_bg1}`}>
                                                <p><span><strong>04.</strong> Daemonic Pronouncement</span></p>
                                            </div>
                                            <div className={`${styles.tble_innr} ${styles.border_btm_mddl} ${styles.tble_innr_bg1}`}>
                                                <p><span><strong>05.</strong> Invocation of Hermes/Apollo</span></p>
                                            </div>

                                            <div className={`${styles.tble_innr} ${styles.border_btm_mddl} ${styles.tble_innr_bg1}`}>
                                                <p><span><strong>06.</strong> Opening of the Gates</span></p>
                                            </div>
                                            <div className={`${styles.tble_innr} ${styles.border_btm_mddl} ${styles.tble_innr_bg1}`}>
                                                <p><span><strong>07.</strong> Invocation of the Daemon
                                                    (Decan Intelligence)</span></p>
                                            </div>
                                            <div className={`${styles.tble_innr} ${styles.tble_innr_bg1}`}>
                                                <p><span><strong>08.</strong> Planetary Pronouncement</span></p>
                                            </div>
                                        </div>

                                        <div className={styles.tble_sec}>
                                            <div className={`${styles.tble_innr} ${styles.border_btm_rght} ${styles.tble_innr_bg2}`}>
                                                <p><span><strong>09.</strong> Planetary Invocation</span></p>
                                            </div>
                                            <div className={`${styles.tble_innr} ${styles.border_btm_rght} ${styles.tble_innr_bg2}`}>
                                                <p><span><strong>10.</strong> Opening of the Gates</span></p>
                                            </div>

                                            <div className={`${styles.tble_innr} ${styles.border_btm_rght} ${styles.tble_innr_bg2}`}>
                                                <p><span><strong>11.</strong> Zodiacal Pronouncement</span></p>
                                            </div>
                                            <div className={`${styles.tble_innr} ${styles.border_btm_rght} ${styles.tble_innr_bg2}`}>
                                                <p><span><strong>12.</strong> Zodiacal Invocation</span></p>
                                            </div>
                                            <div className={`${styles.tble_innr} ${styles.tble_innr_bg2}`}>
                                                <p><span><strong>13.</strong> Closing of the Ritual</span></p>
                                            </div>
                                        </div>
                                    </div>

                                </div>



                            </div>


                        </div>

                        <div className={styles.celestical_invocation_2_Innr}>
                            <div className={`${styles.celestical_invocation_2_Innr_sub} ${styles.flx_wrpr} ${styles.flx_row}`}>

                                <div className={styles.school_ritual_txt_box_wrpr}>
                                    <p>We will now explore the Ritual of the Pentagram in its entirety, encompassing all five variations of our ritual praxis. A clear explanation of each step, the divine intelligences invoked, and the purpose and practice of each version will be provided.</p>
                                    <h3>The Grand Innovation</h3>

                                    <div className={styles.celestial_bullet_wrpr}>

                                        <p>Macrocosmic Alignment (Space Activation)</p>

                                        <ul>
                                            <li>Invocation of <span>'Ehye 'ăšer 'Ehye</span></li>
                                            <li>Invocation of <span>YHVH</span></li>
                                            <li>Invocation of <span>Elohim</span></li>
                                            <li>Invocation of <span>YHVH Elohim</span></li>
                                            <li>Invocation of <span>Kali-Krishna</span></li>

                                        </ul>

                                        <p>Microcosmic Alignment (Self Actualization)</p>

                                        <ul>
                                            <li>Invocation of <span>Hecate</span></li>
                                            <li>Invocation of <span>Helios</span></li>
                                            <li>Invocation of <span>Protogonos</span></li>


                                        </ul>

                                    </div>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>

                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/celestial_img_bg.webp" alt='Image'
                                    />

                                </div>



                            </div>


                        </div>

                    </div>

                </div>

            </LazySection> */}


            <LazySection>

                <div className={`${styles.macrocosmic_invocation_Block1} ${styles.macrocosmic_invocation_Block}`} ref={theMacrocosmicRef}>

                    <div className={styles.common_width}>

                        {/* <div className={styles.column}>
                            <div className={`${styles.col12} ${styles.bgifive}`}>
                                <h2>
                                    The Macrocosmic Invocation
                                </h2>
                            </div>
                        </div> */}


                        <div className={styles.macrocosmic_identification_sub_wrpr}>

                            <div className={`${styles.macrocosmic_identification_sub_Innr} ${styles.flx_wrpr}`}>

                                <div className={styles.school_ritual_txt_box_wrpr}>
                                    <h2>The Macrocosmic Invocation</h2>
                                    <h3>'Ehye 'ăšer 'Ehye</h3>

                                    <h5>I am that I AM - Atman = Brahman - Identification with non-duality</h5>

                                    {/* <p><span>“In the beginning, this was the Self alone, in the shape of a person. Looking around, he saw nothing but himself. He first said: ‘I am.’”</span></p>

                                    <p style={{ textAlign: "right" }}><span><i> - Brihadaranyaka Upanishad 1.4.7</i></span></p> */}

                                    <p>In preparation, <span>“identification”</span> is no different than <span>"entering"</span> into the initial starting state of ritual praxis.  By identifying we automatically <span>“enter”</span> into relationship.  In this first resonate theory we are using the Hebrew <span>“'Ehye,”</span> who is the famous Anthropomorphic <span>“Highest god”</span> in the fire of the burning bush that spoke to Moses.  On the door to my temple I have the following Bible verse. <span>“Take your sandals off your feet for the place you are standing is holy ground Exodus 3:5”</span> I have had that either on the wall or on the door of every temple I have ever put together from the first one I had in my two room apartment in Salem OR in my early 20s.  </p>

                                    <p>There will be a number of places during the ritual where androgeny between the male and female aspects of both the self and Cosmos are very important. Here you can say we are within these limits, but it is much more important to realize that this is an identification with nonduality and in the abstract simply beyond the definitions of gender all together. You both open and close the Pentagram ritual with Ehye as it is the beginning and end of all things. </p>

                                    <p>Ehye 'ăšer 'Ehye stands for  <span>“I am”</span> that <span>“I AM,”</span> identified as undifferentiated and inseparable between the theurgist and the totality state itself, our Divine Infinite Being.  This part of the ritual in self identification is the opening, the entering of sacred space. It has no other predicate outside of pure identification. In the East this is the Atman/Brahman identification, in Platonism there is a perfect parallel where the word <span>“Self”</span> in and of itself simply means the same thing. It is the <span>“One”</span> and the personal <span>“self”</span> together as <span>“Self”</span>.

                                    </p>

                                    <p>
                                        Because theurgy's overall goal is to build principle upon principle, it is Ehye 'ăšer 'Ehye, invoked at both the beginning and end of the ritual, that continuously anchors the ritual experience within the essence of non-duality. As the ritual unfolds, and gods, goddesses, daemons, and divine intelligences are invoked, this non-dual identification binds them together in a unified expression, amplifying the experience. Simultaneously, as the theurgist energetically establishes the ritual space, their expanding identification is constantly drawn back to this unifying principle.

                                    </p>
                                </div>

                                <div className={styles.school_ritual_img_box_wrpr}>

                                    <img
                                        className={styles.school_ritual_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/identification_img_abs.webp" alt='Image'
                                    />

                                    <img
                                        className={styles.abs_img1}
                                        src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/macroscosmic_abs_img_glow.webp" alt='Image'
                                    />

                                </div>

                            </div>


                        </div>


                    </div>

                </div>
            </LazySection>

            <LazySection>

                <div className={`${styles.macrocosmic_invocation_Block2} ${styles.macrocosmic_invocation_Block}`}>

                    <div className={styles.common_width}>



                        <div className={`${styles.macrocosmic_invocation_Block2_Innr} ${styles.flx_wrpr} ${styles.flx_row}`}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>Resonate Divine Name (1 to 3 times)</h3>
                                <p style={{ wordBreak: "break-all" }}><span>Ehye: eeeeeeeehhhhheeeeyyyyyyyyaaaaaaaa</span></p>

                                <p>Facing the altar and the direction of fire, put your finger to the center of your forehead. Within your imaginal body create a brilliant white light above your head, as if the bottom of it was resting on your finger with its bottom curve imagined to be at the very center of your physical brain. As you resonate the following invocation imagine this light being drawn into you filling your entire being. Focus on the Unlimited Unity and the Self as one eternal source <span>“I am (Purusha Atman) that I am (Atman)".</span> </p>

                                <p>
                                    When holding the sign of silence, while still holding the brilliant white light above the head, draw it into your body with every breath in and allow it to radiate with every breath out.
                                </p>

                                <p>
                                    The next two resonate theories of YHVH <span>(Yehova)</span> and Elohim are easily interchanged with either Shiva and Shakti/Parvati or the Thelemic Hadit and Nuit. Not just as whimsical replacements, but because their transcendent natures are of the exact same designation where it matters most.  As I am of a highly syncretistic nature personally I could go either way, and have often worked with Hadit and Nuit. I prefer the Hebrew names for their sonorous effect and their ties to deep kaballistic references, but it is up to the individual practitioner.
                                </p>




                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/microcosmic_img_2_abs.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection>

                <div className={`${styles.macrocosmic_invocation_Block3} ${styles.macrocosmic_invocation_Block}`}>

                    <div className={styles.common_width}>



                        <div className={`${styles.macrocosmic_invocation_Block3_Innr} ${styles.flx_wrpr}`}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>YHVH</h3>
                                <h5>Alignment with the Divine Will of the Dēmiurgós, the eternal male
                                    principle of the creator</h5>

                                <p>The next step is to deeply align with the eternal male principle and the infinite center of being. This resonant theory is rooted in deep Kabbalistic interpretations of the divine name YHVH, or Yod, He, Vau, He. At this abstract stage in the Ritual of the Pentagram, the importance lies not just in the letters themselves but in their ability to draw the theurgist to their innermost center— the center of all Being, equated here with the omnicentric father, the Singularity.
                                </p>

                                <p>
                                    The Yod, the first letter of the name, uniquely floats above the line, untouched. Zohar 1:2b-3b states, <span>"Yod is the smallest of all letters. It is the first point, which is the thought or the spark of all creation, from which all other letters are generated. It is the essence and the root from which all else flows."</span> It is regarded as the source of all other letters and represents the <span>"divine spark."</span> However, this should not be viewed as an initiating spark, such as one might see from flint against steel, but rather as the spark of awareness in the theurgist of this eternal, beginningless origin of all existence within their very center. In the Zohar, this is referred to as <span>"the hidden point."</span>

                                </p>

                                <p>

                                    The Yod symbolizes the manifest center of all being, the Singularity itself. To resonate with YHVH is to invoke through the name the beginningless and endless central origin of all the manifest worlds, which are rooted in the four worlds of emanation. For our purposes in this ritual, these can be simply equated with fire, water, air, and earth, although these fourfold divisions are prevalent throughout our literature and religious thought agnostically.
                                </p>

                                <p>

                                    Being the <span>"beginningless"</span> center of being, which can be described as the <span>"proximity"</span> or <span>"axis"</span> from which the manifest ritual unfolds, one should concentrate on the Yod as the apex within the manifest fourfold divisions of the name in the Pentagram Ritual. This is revealed through the remainder of the ritual when the gates of the elements are cast in the drawing of the Pentagrams.

                                </p>

                                <p>
                                    Chaim Vital, commenting on the Zohar, explains: <span>“When it arose in the Divine Will to create worlds and emit the emanated [light], He contracted (Tzimtzum) Himself at the point of the center, in the very center, He contracted the light, distancing it to the sides surrounding the central point, so that there remained a void, a hollow empty space, away from the central point.”</span> This describes the Singularity, where the geocedics of spacetime terminate into infinite curvature <span>(see Central Doctrine)</span>.
                                </p>



                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/macrocosmic_img_3_abs.webp" alt='Image'
                                />

                                <img
                                    className={styles.abs_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/glow_img_abs.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection>

                <div className={`${styles.macrocosmic_invocation_Block4} ${styles.macrocosmic_invocation_Block}`}>

                    <div className={styles.common_width}>



                        <div className={`${styles.macrocosmic_invocation_Block4_Innr} ${styles.flx_wrpr} ${styles.flx_row}`}>

                            <div className={styles.school_ritual_txt_box_wrpr}>


                                <p>Consider this quote from Osho to assist in understanding: <span>“Man has no center separate from the whole.”</span> The <span>"contracting"</span> point, the Tzimtzum, is the Singularity, a point of infinite mass and gravity found at the center of every point in spacetime, including the personal being. As you resonate with the name YHVH and focus on this infinite center, the origin, you should experience it contracting and simultaneously expanding a void of empty awareness. As Shambhavi articulates, <span>“The law of spiritual growth posits that the deeper the center, the wider its circumference.”</span> At this juncture, all that exists is an infinite perimeter emanating from this center in all directions—the deeper the center, the closer to the origin, the further it emanates away, expanding the theurgist’s field of awareness and preparing the ritual space for illumination.
                                </p>

                                <p>
                                    Plotinus, in Enneads <span>(V.1 [10])</span>, states: <span>"The production of the universe by the Demiurge is the outcome of his contemplation: he looks to the higher and brings forth; he is as it were the father, and the
                                        Intellectual-Principle stands to him as mother, the source of his creative act."</span> The resonant theory of YHVH, often conflated with the Platonic Demiurge, involves an act of identification with the Divine Will of the Father, wherein the expanding space represents the landscape of awareness of God itself,
                                    manifesting through the theurgist who opens their field of awareness in <span>"state preparation"</span> <span>(see
                                    Central Doctrine)</span> for the eyes to turn inward towards the realization of eternal and infinite principles. Through this identification, the theurgist prepares the space for the appearances of the <span>"Intellectual-Principle,"</span> the feminine dynamic manifestations of divinatory and revelatory experience within the body of the goddess, the visionary states of the ritual.

                                </p>

                                <h3>Resonate Divine Name (1 to 3 times)</h3>
                                <p><span>Yehova - yyyyyeeeeeeehhhhhoooooovvvvvaaaaaa</span></p>

                                <p>While still holding the brilliant white light above the head drawing it into your body with every breath in and allowing it to radiate with every breath out now concentrate on the center of being.  This is a
                                    positionless <span>"proximity"</span> and beginningless <span>“origin”</span> which will by its own nature centralize within your awareness but it may be of benefit in the beginning to allow this center to be concentrated on the
                                    position of the third eye. We are still in abstraction and here you want to imagine the infinite will of the father radiating in every direction amplifying the field of the light body, preparing an empty space that completely surrounds you.  </p>
                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/macrocosmic_img_4_abs.webp" alt='Image'
                                />

                                <img
                                    className={styles.abs_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/macrocosmic_img_4_glow_abs.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>

            </LazySection>

            <LazySection>

                <div className={`${styles.macrocosmic_invocation_Block5} ${styles.macrocosmic_invocation_Block}`}>

                    <div className={styles.common_width}>



                        <div className={`${styles.macrocosmic_invocation_Block5_Innr} ${styles.flx_wrpr}`}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>Elohim</h3>
                                <h5>The Cosmic Horizon and Womb of the Cosmos, the Spherical Void,
                                    the divine feminine principle</h5>

                                <p>We have now identified with the Non-dual state of Ehye and then focused on the very center of being, the origin which is infinite and beginningless and thereby pushed in all directions an expansion of pure awareness. Now we come to the resonate theory of Elohim. Zohar states The <span>"central point,"</span> can be clearly seen <span>"within the palace,"</span> as depicted in the Zohar, I, 2b-3a:15a-b: <span>"With this beginning, the unknown concealed one created the palace. This palace is called Elohim (God). He engraved it with a hidden spark of impenetrable darkness and made an enclosure around this point."</span> Elohim, the divine feminine is the <span>“Shekinah.”</span> The Zohar II, 161a states: <span>"The Shekhinah is the ayin (nothingness) from which everything emerges."</span> In Zohar I, 16a, it states: <span>"When the Blessed Holy One created the world, He created it male and female. The female is the tehom (abyss)..."</span> Hayyim Vital, in the Sha'ar Ha-Hakdamot written in the late 16th century, stated: <span>"The tehom (abyss) is the source of all… It is the primordial womb from which all creation is born."</span> In Zohar II, 91b, we read: <span>"The Shekhinah is the garden of Eden from which all souls emerge. She is the hidden treasure, the secret of all secrets."</span>
                                </p>

                                <p>The unlimited void, the vastness of space which within our universe terminates at the Cosmic Horizon, and although extending far beyond into the vastness of the unknown greater spacetime of the multiverse, the Spherical Cosmic Horizon, where expanding space reaching the light limit, we find the great feminine womb itself, the source of all universal forms that project in from this perimeter.  The Theurgist, resonating Elohim, finds himself at the very center of this infinitely expanding spherical Cosmic Horizon, as is every other point in spacetime <span>(see Central Doctrine)</span>. While resonating one concentrates on an infinitely expanding spherical horizon that is emanating back to the very center of their physical being.  The void of space becomes the <span>“fertile”</span> feminine where the <span>"Intellectual-Principle,"</span> will manifest the ecstatic visions of divinatory and revelatory experience.
                                </p>

                                <h3>Resonate Divine Name (1 to 3 times)</h3>
                                <p><span>Elohim - Elllllllooooohhhhhhhhiiiiiiiimmmmmmmmmmm</span></p>
                                <p>Maintaining focus on the brilliant white light above your head, continue to draw it into your body with each inhale and allow it to radiate outward with each exhale. Simultaneously, focus on the immediacy of being, the will of the Father, radiating in all directions. Now resonating Elohim you are going to envision an <span>"infinite spherical enclosure."</span> Envision the womb of space as a spherical boundary expanding infinitely outward. As it expands, imagine a <span>"fertile"</span> potency radiating back from every point along its perimeter to the very center of being, ripe with potential. This process encloses you, the theurgist, within the fertile womb of the void, framing the divinatory space where visionary experiences emerge.</p>
                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/macrocosmic_img_5_abs.webp" alt='Image'
                                />

                                <img
                                    className={styles.abs_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/macrocosmic_img_5_glow_abs.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection>


                <div className={`${styles.macrocosmic_invocation_Block6} ${styles.macrocosmic_invocation_Block} `}>

                    <div className={styles.common_width}>



                        <div className={`${styles.macrocosmic_invocation_Block6_Innr} ${styles.flx_wrpr} ${styles.flx_row}`}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>YHVH-Elohim</h3>
                                <h5>The amplification of the masculine/feminine principle Macrocosmic space</h5>

                                <p>To amplify and tune the frequency between the male principle of YHVH and the feminine principle of Elohim, concentrate on resonating them together as a continuum. While doing this, continue to hold the brilliant white light above your head, drawing the light into your body with each inhale and radiating it outward with each exhale. Focus on both forms simultaneously, as described above, integrating their energies through your breathwork.
                                </p>

                                <h3>Resonate Divine Name (1 to 3 times)</h3>
                                <p><span>YHVH Elohim - Yyyyyeeehhhooovvaaa Elllloohhhhhiiiiimmmmmmm</span></p>
                                <p>Now focusing on the principles of YHVH as the center of being that is contracting pushing the space of awareness focus on this energy fusing with the infinite perimeter of the spherical boundary of the void amplifying their ecstatic relationship bringing divine energy into the relationship rising to the point of manifestation within their infinite embrace.</p>

                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/macrocosmic_img_6_abs.webp" alt='Image'
                                />

                                <img
                                    className={styles.abs_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/macrocosmic_img_6_glow_abs.webp" alt='Image'
                                />

                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection>

                <div className={`${styles.macrocosmic_invocation_Block7} ${styles.macrocosmic_invocation_Block} `}>

                    <div className={styles.common_width}>



                        <div className={`${styles.macrocosmic_invocation_Block7_Innr} ${styles.flx_wrpr}`}>

                            <div className={styles.school_ritual_txt_box_wrpr}>
                                <h3>Kali-Krishna</h3>
                                <h5>Self identification with the highest Cosmic Union of the the Macrocosm</h5>

                                <p>Understanding the anthropic form of Kali-Krishna, as defined in our Central Doctrine, is crucial for this part of the ritual. More than any other element, it demands the student's full comprehension.
                                    Kali-Krishna represents the highest form of the Macrocosm, and at this stage, the theurgist identifies with this transcendent form, encompassing the entire Cosmos—indeed, this identification extends
                                    directly to the eternal, expanding spacetime geometric unity of the multiverse. As an expression of
                                    Kali-Krishna, the central omnicentric Observer, the Singularity, and the deepest form of divine energy <span>(Kali)</span>, the physical incarnating Cosmos merges with the theurgist. It is Krishna, representing the
                                    infinite expressibility of experience, and Kali, the body of all manifestation <span>(both mental and physical)</span>, that are the active principles incarnated within the theurgist. These principles become both the
                                    theurgist's center of awareness and the very body through which visionary experience manifests within the void.
                                </p>


                                <p> It states in the Devi Bagavatam, <span>"Krishna, known as the highest Purusha, transcends the limits of birth and death and governs all cosmic manifestations as the sovereign of the universe... Krishna, the Lord of all, the true Purusha, the supreme entity, the eternal one, the divine Brahman, manifested Himself as the foremost of all beings in this universe."</span> </p>

                                <p>
                                    It is further stated, <span>"The Supreme Goddess resides within Krishna, enhancing his play and pastimes within the infinite universes that emanate from him. As the divine mother, she manifests alongside him, enriching the cosmic dance."</span> The scripture continues, <span>"In every hair pore of this Cosmic Form of Krishna, innumerable universes are found. He is the original person, the oldest, the first-born of all the existing things. He is verily the Purusha, witnessed as the whole universe."</span> This passage designates Lord Krishna as the <span>"original person"</span> and <span>"the oldest"</span>, the <span>"first-born"</span>, a designation made by Guidiay Vishnavism as <span>“The Original Supreme Personality of Godhead.”</span> And Krishna is you in your most
                                    intimate self, but he is the immortal you, it is through his eyes that we bear witness to the eternal nature of the self.
                                </p>

                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/kalimaa_abs_img.webp" alt='Image'
                                />

                                <img
                                    className={styles.abs_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/kalimass_glow_img_abs.webp" alt='Image'
                                />


                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

            <LazySection>

                <div className={`${styles.macrocosmic_invocation_Block8} ${styles.macrocosmic_invocation_Block} `}>

                    <div className={styles.common_width}>



                        <div className={`${styles.macrocosmic_invocation_Block8_Innr} ${styles.flx_wrpr} ${styles.flx_row}`}>

                            <div className={styles.school_ritual_txt_box_wrpr}>


                                <p><span>“Kali herself is Maharatri, 'the great universal night' wherein everything merges into the vastness of cosmic space. In her power of dissolution, she brings about a termination, disbanding and conclusion of all moha, delusion, and maya, the illusion. Kali in her aspect as Goddess Guhyavidya, 'the secret knowledge', is the Divine Mother bestowed with all spiritual and occult wisdom beyond the range of the human mind and senses.”</span>
                                </p>

                                <p style={{ textAlign: "right" }}><span><i>- Shambhavi Chopra, Yogic Secrets of the Dark Goddess</i></span></p>

                                <p><span>"In the vibration of Her dance, all that is solid melts, all that is manifest dissolves, and the universe emerges from the cosmic void. This is the dance of Kali, who is both the void and the vibration, both the destroyer and the creator."</span></p>

                                <p style={{ textAlign: "right" }}><span><i>- Śiva Sutras, (800/900 CE)</i></span></p>

                                <p>
                                    As the ritual progresses, the theurgist adopts the role of Krishna, the ontic supra-personal source from which all gods and divine intelligences emanate. Within this identification, Krishna is not one god among others but the radiant ground of divinity itself—the infinite Personhood in whom all divine masks and agencies arise, move, and return. The theurgist navigates the ritual as a play of this infinite Persona, while the fundamental structure of the universe is embodied by Kali, who manifests all levels of reality, from the solidity of matter to the luminous body of visionary experience.</p>
                                    <p>The identification with Kali is crucial, for she is the fierce power of dissolution and the luminous matrix of manifestation alike. In many ceremonial traditions, elaborate protections are employed to shield the practitioner from hostile or chaotic forces. In our praxis, this protection is unnecessary: through the invocation of Kali, every illusory or dangerous current is utterly destroyed in the brilliance of her presence. Her energies are not defensive but annihilating, a complete transmutation that leaves nothing unpurified.</p>
                                    <p>Thus, within the ritual the theurgist becomes the living intersection of Kali and Krishna—Krishna as the eternal supra-personal source of all divine intelligences, and Kali as the cosmic unfolding and collapsing of all appearances. Together they reveal the theurgical secret: that all planetary gods and zodiacal intelligences are radiant emanations of Krishna’s infinite Personhood, articulated through the dynamic powers of Kali’s manifold manifestations. To invoke them is to enter into their eternal union, standing as a microcosmic expression of the entire cosmos—the soul aligned to the source and sustained in the living rhythm of divine play.</p>

                                <h3>Resonate Divine Name (1 to 3 times)</h3>
                                <p><span style={{ wordBreak: "break-all" }}>Kali-Krishna - Kaaaallllliiiiiiiiikkkkrrrriiissshhhhnnnnaaaaa</span></p>
                                <p>
                                    Maintain your focus on the brilliant white light above your head. With each inhale, draw this light into your body, and with each exhale, allow it to radiate outward. Simultaneously, concentrate on the immediacy of being and the will of the Father, YHVH, which contracts into your center and radiates in all directions, vibrating back from every point of the infinitely expanding boundary of Elohim. Now resonate with Kali-Krishna. Let Krishna, the incarnating force of the Father, become the very point of your indestructible awareness. Merge this awareness with the contracting center of YHVH at your third eye, while also blending the dynamic energy of the goddess Kali with Elohim. Feel the deep fertility of the endless void radiating in from the infinite spherical boundary, teeming with dynamic energy. Experience the God and Goddess of the Multiverse merging at the central point of your being.
                                </p>

                            </div>

                            <div className={styles.school_ritual_img_box_wrpr}>

                                <img
                                    className={styles.school_ritual_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/krishna_img_abs.webp" alt='Image'
                                />

                                <img
                                    className={styles.abs_img1}
                                    src="https://d37pbainmkhx6o.cloudfront.net/transcendentpagan/school_ritual/krishna_img_glow_abs.webp" alt='Image'
                                />


                            </div>

                        </div>





                    </div>

                </div>
            </LazySection>

        </>
    )
}

export default Block2
